export default {
    name: 'Physton/sd-webui-prompt-all-in-one',
    shortName: 'sd-webui-prompt-all-in-one',
    github: 'https://github.com/Physton/sd-webui-prompt-all-in-one',
    nameAssets: 'Physton/sd-webui-prompt-all-in-one-assets',
    shortNameAssets: 'sd-webui-prompt-all-in-one-assets',
    githubAssets: 'https://github.com/Physton/sd-webui-prompt-all-in-one-assets',
    gitee: 'https://gitee.com/Physton/sd-webui-prompt-all-in-one',
    docs: 'https://aiodoc.physton.com',
    nameTagComplete: 'DominikDoom/a1111-sd-webui-tagcomplete',
    shortNameTagComplete: 'a1111-sd-webui-tagcomplete',
    githubTagComplete: 'https://github.com/DominikDoom/a1111-sd-webui-tagcomplete',
    civitaiUrl: 'https://civitai.com',
}